module.exports = __webpack_public_path__ + "assets/img/1001.8842d96c.svg";